import { render, staticRenderFns } from "./advisorComingSoon.vue?vue&type=template&id=94efa3e0&scoped=true"
import script from "./advisorComingSoon.vue?vue&type=script&lang=js"
export * from "./advisorComingSoon.vue?vue&type=script&lang=js"
import style0 from "./advisorComingSoon.vue?vue&type=style&index=0&id=94efa3e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94efa3e0",
  null
  
)

export default component.exports